/**
 * @package checkout
 */

const ACCOUNT_TYPE_PRIVATE = 'private';
const ACCOUNT_TYPE_BUSINESS = 'business';

// eslint-disable-next-line sw-deprecation-rules/private-feature-declarations
export default Object.freeze({
    ACCOUNT_TYPE_PRIVATE,
    ACCOUNT_TYPE_BUSINESS,
});
